import { render, staticRenderFns } from "./up_scan.vue?vue&type=template&id=6b506500&scoped=true&"
import script from "./up_scan.vue?vue&type=script&lang=js&"
export * from "./up_scan.vue?vue&type=script&lang=js&"
import style0 from "./up_scan.vue?vue&type=style&index=0&id=6b506500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b506500",
  null
  
)

export default component.exports